export default {
    name: 'onlyInputNum',
    bind: function(el, binding) {
        const re = /\d/;
        el.dsHandler = function(e) {
            e = e || window.event;
            const charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
            // 输入.
            if(binding.modifiers.float) {
                if(charcode == 46) {
                    if(el.value && el.value.includes('.')) {
                        e.preventDefault();
                    }
                    return;
                }
            }
            if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
                if(e.preventDefault) {
                    e.preventDefault();
                }else {
                    e.returnValue = false;
                }
            }
        };
        el.addEventListener("keypress", el.dsHandler);
    },
    update: function(el, binding) {
        const re = /\d/;
        const value = binding.value[binding.arg];
        if(re.test(value)) {
            if(binding.modifiers.zero) {
                binding.value[binding.arg] = value;
            }else {
                binding.value[binding.arg] = Number(parseInt(value));
            }
        }else {
            binding.value[binding.arg] = null;
        }
    },
    unbind: function(el) {
        el.removeEventListener("keypress", el.dsHandler);
    }
};
